const QuoteSection = () => (
  <section className="quote-section">
    <p className="quote-text">
      <span className="quote">
        “The purpose of a tax cut is to leave more money where it belongs: in
        the hands of the working men and working women who earned it in the
        first place.”
      </span>
      <br />
      <span className="quote-author">– Bob Dole</span>
    </p>
  </section>
);

export default QuoteSection;
